$( document ).ready(function() {


	// PRODUCT SLIDER
	product_slider = new Swiper ('.product-slider', {
		slidesPerView: 1,
		speed: 600,
		loop: false,
		initialSlide: 0,
		allowTouchMove: false,
		effect: 'fade',
		autoHeight: true,
		calculateHeight: true,
		fadeEffect: {
			crossFade: true
		},
		on: {
			slideChange: function () {
			}
		}
	});

	// updates slider based on flavor - Single Product Page
	$('.selects .single-option-selector__radio').change(function(){

	    let flavor = $("input[name='option1']:checked").val();

	    let slide = $('[data-flavor="' + flavor + '"]');
	    let index = $('.product-slider .swiper-slide').index( slide );
	    product_slider.slideTo( index );

	});

	// updates flavor and strength selectors based on slider navigation arrows
	$('.swiper-button-next,.swiper-button-prev').click( update_selectors );

	// price update
	product_slider.on('slideChange',function(){

		let active_slide = $( product_slider.slides[ product_slider.activeIndex ] );

		$('.right .price').text( '$' + ( active_slide.data('price') / 100 ) );

		$('#ProductSelect--product-template option[value=' + active_slide.data('id') + ']').prop('selected','selected');


		// update url variant querystring
		let slug = active_slide.data('slug');

		let urlParams = new URLSearchParams(window.location.search);
		if ( urlParams.has('variant') ) {
			urlParams.set('variant', slug);
		} else {
			urlParams.append('variant', slug);
		}
		history.pushState( null, '', location.pathname + '?' + urlParams.toString() );
	});

	// show variant from url
	let urlParams = new URLSearchParams(window.location.search);
	let slide = $('[data-slug="' + urlParams.get('variant') + '"]');
	let index = $('.product-slider .swiper-slide').index( slide );
	product_slider.slideTo( index );
	update_selectors();

function update_selectors(){
	setTimeout(function(){
		$('[name=option1]').attr('checked',false);
		let flavor = $('.product-slider .swiper-slide-active').data('flavor');
		$('[name=option1][value="' + flavor + '"]').attr('checked',true);

	}, 100);
}

});
